module.exports = __webpack_public_path__ + "img/food-hero-econom-m.757b12e1.jpg";